import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Suppliers from "@/pages/Suppliers";
import Parts from "@/pages/Parts";
import GRNs from "@/pages/GRNs";
import GRNView from "@/pages/GRNView";
import Inventory from "@/pages/Inventory";
import Boxes from "@/pages/Boxes";
import BoxView from "@/pages/BoxView";
import PackingLists from "@/pages/PackingLists";
import PackingListView from "@/pages/PackingListView";
import Traceability from "@/pages/Traceability";
import Reports from "@/pages/Reports";
import AssemblyRuns from "@/pages/AssemblyRuns";
import AssemblyRunView from "@/pages/AssemblyRunView";
import AssemblyRunLabels from "@/pages/AssemblyRunLabels";
import BoxLabel from "@/pages/BoxLabel";
import BoxLabelsBulk from "@/pages/BoxLabelsBulk";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Staff from "@/pages/Staff";
import Operations from "@/pages/Operations";
import Schedule from "@/pages/Schedule";
import Timesheets from "@/pages/Timesheets";
import JobCard from "@/pages/JobCard";
import ScheduleWallChart from "@/pages/ScheduleWallChart";
import TeamJobTracker from "@/pages/TeamJobTracker";
import Kiosk from "@/pages/Kiosk";
import WorkforceReports from "@/pages/WorkforceReports";
import Dispatches from "@/pages/Dispatches";
import WeeklySnapshot from "@/pages/WeeklySnapshot";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              className: "brut-card font-mono-ui",
              style: { borderRadius: 0, border: "2px solid #1e293b" },
            }}
          />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/kiosk" element={<Kiosk />} />

            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout><Dashboard /></Layout>
                </ProtectedRoute>
              }
            />
            <Route path="/suppliers" element={<ProtectedRoute><Layout><Suppliers /></Layout></ProtectedRoute>} />
            <Route path="/parts" element={<ProtectedRoute><Layout><Parts /></Layout></ProtectedRoute>} />
            <Route path="/grns" element={<ProtectedRoute><Layout><GRNs /></Layout></ProtectedRoute>} />
            <Route path="/grns/:id" element={<ProtectedRoute><Layout><GRNView /></Layout></ProtectedRoute>} />
            <Route path="/inventory" element={<ProtectedRoute><Layout><Inventory /></Layout></ProtectedRoute>} />
            <Route path="/boxes" element={<ProtectedRoute><Layout><Boxes /></Layout></ProtectedRoute>} />
            <Route path="/boxes/:id" element={<ProtectedRoute><Layout><BoxView /></Layout></ProtectedRoute>} />
            <Route path="/packing-lists" element={<ProtectedRoute><Layout><PackingLists /></Layout></ProtectedRoute>} />
            <Route path="/packing-lists/:id" element={<ProtectedRoute><Layout><PackingListView /></Layout></ProtectedRoute>} />
            <Route path="/trace" element={<ProtectedRoute><Layout><Traceability /></Layout></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Layout><Reports /></Layout></ProtectedRoute>} />
            <Route path="/assembly-runs" element={<ProtectedRoute><Layout><AssemblyRuns /></Layout></ProtectedRoute>} />
            <Route path="/assembly-runs/:id" element={<ProtectedRoute><Layout><AssemblyRunView /></Layout></ProtectedRoute>} />
            <Route path="/assembly-runs/:id/labels" element={<ProtectedRoute><AssemblyRunLabels /></ProtectedRoute>} />
            <Route path="/boxes/:id/label" element={<ProtectedRoute><BoxLabel /></ProtectedRoute>} />
            <Route path="/productions" element={<ProtectedRoute><Layout><AssemblyRuns /></Layout></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute roles={["admin"]}><Layout><Users /></Layout></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute roles={["admin"]}><Layout><Settings /></Layout></ProtectedRoute>} />
            <Route path="/staff" element={<ProtectedRoute><Layout><Staff /></Layout></ProtectedRoute>} />
            <Route path="/operations" element={<ProtectedRoute><Layout><Operations /></Layout></ProtectedRoute>} />
            <Route path="/schedule" element={<ProtectedRoute><Layout><Schedule /></Layout></ProtectedRoute>} />
            <Route path="/schedule/print" element={<ProtectedRoute><JobCard /></ProtectedRoute>} />
            <Route path="/schedule/wall-chart" element={<ProtectedRoute><ScheduleWallChart /></ProtectedRoute>} />
            <Route path="/schedule/team-tracker" element={<ProtectedRoute><TeamJobTracker /></ProtectedRoute>} />
            <Route path="/timesheets" element={<ProtectedRoute><Layout><Timesheets /></Layout></ProtectedRoute>} />
            <Route path="/workforce-reports" element={<ProtectedRoute><Layout><WorkforceReports /></Layout></ProtectedRoute>} />
            <Route path="/dispatches" element={<ProtectedRoute><Layout><Dispatches /></Layout></ProtectedRoute>} />
            <Route path="/weekly-snapshot" element={<ProtectedRoute><WeeklySnapshot /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
